export default "__VITE_ASSET__69190e0d__"